/* eslint-disable no-console */

import { register } from 'register-service-worker'

const CANONICAL_ORIGIN = 'https://reabilitaretermica.eu'

async function abandonWwwOrigin () {
  if (!/^www\./i.test(window.location.hostname)) {
    return false
  }

  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))
  }

  if ('caches' in window) {
    const keys = await caches.keys()
    await Promise.all(keys.map((key) => caches.delete(key)))
  }

  const { pathname, search, hash } = window.location
  window.location.replace(`${CANONICAL_ORIGIN}${pathname}${search}${hash}`)
  return true
}

if (process.env.NODE_ENV === 'production') {
  abandonWwwOrigin().then((abandoned) => {
    if (abandoned) {
      return
    }

    register(`${process.env.BASE_URL}service-worker.js`, {
      ready () {
        console.log(
          'App is being served from cache by a service worker.\n' +
          'For more details, visit https://goo.gl/AFskqB'
        )
      },
      registered () {
        console.log('Service worker has been registered.')
      },
      cached () {
        console.log('Content has been cached for offline use.')
      },
      updatefound () {
        console.log('New content is downloading.')
      },
      updated () {
        console.log('New content is available; please refresh.')
        window.location.reload(true)
      },
      offline () {
        console.log('No internet connection found. App is running in offline mode.')
      },
      error (error) {
        console.error('Error during service worker registration:', error)
      }
    })
  })
}
